<template>
    <ContentWrapper class="mt-4">
        <div class="bg-white p-6 rounded shadow">
            <img v-bind:src="getImage()" class="block w-full" />
        </div>
    </ContentWrapper>
</template>

<script>
import ContentWrapper from './../components/controls/ContentWrapperControl.vue';
import mixin from './../mixin.js';

export default {
    mixins: [
        mixin,
    ],
    components: {
        ContentWrapper,
    },
    mounted() {
        let title = this.lang('not.found');

        this.$emit('shownavbar', {
            title: title,
            show: true,
            back: true,
        });
    },
    methods: {
        getImage() {
            return this.getMediaPath("/page-not-found.jpg");
        }
    }
}
</script>